import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { GhostButton } from '@/components/ui-kit/Buttons'
import { Headline } from '@/components/ui-kit/Primitives'
import { PhoneShell } from '@/components/PhoneShell'
import { sectionsFor, type LegalPage as Page } from '@/content/legal'

/**
 * Datenschutzerklärung und Impressum auf dem Handy.
 *
 * Eine lange, scrollbare Textseite - dieselbe Struktur wie in der Konsole,
 * nur im Handy-Rahmen. Erreichbar ohne Beitritt.
 */
export default function LegalPage({ page }: { page: Page }) {
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()

    return (
        <PhoneShell>
            <div className="wb-scroll flex flex-1 flex-col overflow-y-auto">
                <span className="text-xs font-extrabold tracking-[.25em] text-wb-accent uppercase">
                    {t('app.name')}
                </span>

                <Headline className="mt-4 text-2xl">{t(`legal.${page}.title`)}</Headline>
                {/* Der gelieferte Datenschutztext hat keinen Einleitungssatz. */}
                {i18n.exists(`legal.${page}.intro`) && (
                    <p className="mt-2 text-sm text-wb-dim">{t(`legal.${page}.intro`)}</p>
                )}

                <div className="mt-6 flex flex-col gap-5 pb-6">
                    {sectionsFor(page).map((section) => (
                        <section key={section}>
                            <h2 className="text-base font-extrabold">
                                {t(`legal.${page}.sections.${section}.title`)}
                            </h2>
                            <p className="mt-1.5 text-[13px] leading-relaxed whitespace-pre-line text-wb-dim">
                                {t(`legal.${page}.sections.${section}.body`)}
                            </p>
                        </section>
                    ))}
                </div>
            </div>

            <GhostButton className="mt-3" onClick={() => void navigate(-1)}>
                ‹ {t('legal.back')}
            </GhostButton>
        </PhoneShell>
    )
}
